<template>
  <div class="login-modal" v-if="visible">
    <template v-if="type === 'ROLE'">
      <RoleSelect @success="roleSuccess" @close="handleCancel" />
    </template>

    <div v-else class="login-box">
      <div class="close-button" @click="handleCancel">
        <a-icon type="close" />
      </div>
      <div class="login-top">
        <img class="login-logo" src="@/assets/images/header-logo.png" alt="" />
      </div>
      <div class="login-tab-box">
        <CustomTab
          :ARRAY="['短信验证登录', '账号密码登录']"
          :ACTIVE="activeLoginTab"
          @change="tabChange"
        />
      </div>
      <CodeLogin v-if="activeLoginTab === 0" @success="loginSuccess" />
      <AccountLogin v-if="activeLoginTab === 1" @success="loginSuccess" />
    </div>
  </div>
</template>

<script>
import CustomTab from "@/components/CustomTab/index.vue";
import CodeLogin from "./code-login.vue";
import AccountLogin from "@/components/CustomLogin/account-login.vue";
import RoleSelect from "@/components/CustomLogin/role-select.vue";
import { mixinAnimate } from "@/mixins/animate";
export default {
  components: { RoleSelect, AccountLogin, CodeLogin, CustomTab },
  mixins: [mixinAnimate],
  data() {
    return {
      visible: false,
      resolve: null,
      reject: null,
      loginForm: this.$form.createForm(this),
      accountForm: this.$form.createForm(this),
      type: "LOGIN",
      activeLoginTab: 0,
      roleGsap: null,
      loginGsap: null,
    };
  },
  methods: {
    loginSuccess(token) {
      this.visible = false;
      if (this.resolve) this.resolve(token);
    },
    roleSuccess(user) {
      this.visible = false;
      if (this.resolve) {
        this.resolve(user);
      }
    },
    // 类型切换
    tabChange(index) {
      this.activeLoginTab = index;
    },
    // 打开登录
    show(options = {}) {
      this.visible = true;
      if (options && options.TYPE) {
        this.type = options.TYPE;
        this.$nextTick(() => {
          if (options.TYPE === "ROLE") {
            this.initComponent(
              this.roleGsap,
              ".role-all-item",
              0,
              1,
              "y",
              200,
              0,
              0.5,
              "power2.out"
            );
          }

          if (options.TYPE === "LOGIN") {
            this.initComponent(
              this.loginGsap,
              ".login-box",
              0,
              1,
              "y",
              -600,
              0,
              0.5,
              "power2.out"
            );
          }
        });
      }
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    hide() {
      this.visible = false;
      this.loginForm.resetFields();
    },

    handleCancel() {
      this.hide();
      if (this.reject) {
        this.reject("cancel");
      }
    },

    // handleSubmit(event) {
    //   event.preventDefault();
    //   this.loginForm.validateFields((err, values) => {
    //     if (!err) {
    //       this.loading = true;
    //       this.login(values);
    //     }
    //   });
    // },
  },
};
</script>

<style lang="scss" scoped>
.login-modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 200;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  .login-box {
    width: 420px;
    background-color: #ffffff;
    box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.11);
    border-radius: 8px;
    padding: 36px 40px 50px;
    position: relative;
    z-index: 260;

    .close-button {
      position: absolute;
      top: 0;
      right: -20px;
      font-size: 16px;

      :hover {
        cursor: pointer;
      }
    }

    ::v-deep(.ant-input, .ant-input-affix-wrapper) {
      width: 340px;
      height: 40px;
      outline: none;
      box-shadow: none;
      border-radius: 2px;
      border: 1px solid #d9d9d9;
    }

    .login-top {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;

      .login-logo {
        width: 263px;
        height: 42px;
      }
    }

    .login-tab-box {
      margin-top: 37px;
    }

    .login-account-code {
      margin-top: 25px;

      .sjh {
        width: 16px;
        height: 16px;
      }

      .tip {
        font-weight: 400;
        font-size: 14px;
        color: #dddddd;
        line-height: 24px;
      }

      .yzm-button {
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        line-height: 22px;

        &:hover {
          cursor: pointer;
        }
      }

      .login-button {
        width: 340px;
        height: 40px;
        background-color: #0067db;
        border-radius: 2px;
        font-weight: 500;
        font-size: 16px;
        color: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .login-yhxy-box {
        margin-top: 16px;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        line-height: 22px;
      }
    }
  }
}
</style>
